import { Component } from '@angular/core';
import { TableColumnDirective } from '../column.directive';
import { SyncStyle } from '../../../../local-seo';

@Component({
  selector: 'local-seo-status-column',
  templateUrl: './status-column.component.html',
  styleUrls: ['./status-column.component.scss'],
  standalone: false,
})
export class StatusColumnComponent extends TableColumnDirective {
  constructor() {
    super();
  }

  openUpgradeDialog(): void {
    this.eventEmitter.emit({ openUpgradeDialog: true });
  }

  getTextClassForStyle(style: SyncStyle) {
    return style + '-text';
  }

  getIconClassForStyle(style: SyncStyle) {
    return style + '-icon';
  }
}
